// Single source of truth for the portal's inactivity timeout, so on-screen text
// that names the number of minutes cannot drift from the timer that actually
// signs the user out (SignOutWarningModal, mounted in AppShell).
//
// VITE_IDLE_TIMER_TIMEOUT is not set in any .env file or workflow, so the
// 20-minute default below is what applies in both test and prod.
export const IDLE_TIMER_TIMEOUT_MS = parseInt(
  import.meta.env.VITE_IDLE_TIMER_TIMEOUT ?? "1200000",
);

export const IDLE_TIMER_TIMEOUT_MINUTES = Math.round(
  IDLE_TIMER_TIMEOUT_MS / 60000,
);
